/**
 * KAN-880: общие фильтры доски и таблицы CRM в адресе и в запросе:
 * ?search=<текст>&manager=me|<uuid>|none|all. В params запроса уходят только заданные фильтры.
 * KAN-909: manager=all - явный выбор "Все менеджеры" (в запрос не уходит);
 * флажка stale ("Без движения больше 7 дней") больше нет.
 * KAN-910: в адресе пишется итоговое значение (в том числе all), ссылка у получателя не меняется.
 */
import type { CrmLeadFilterParams, CrmLeadFilters } from '@/types/crmPipeline';

export const CRM_FILTER_PARAM = { search: 'search', manager: 'manager' } as const;

/** Фильтр по менеджеру: свои лиды (у входа со своей записью менеджера). */
export const MANAGER_FILTER_ME = 'me';
/** Фильтр по менеджеру: лиды без менеджера. */
export const MANAGER_FILTER_NONE = 'none';
/** KAN-909: явный выбор "Все менеджеры" (отличается от "ещё не выбирал"). */
export const MANAGER_FILTER_ALL = 'all';

/** Фильтры из адреса: пустой manager и manager=all = null (без фильтра). */
export function parseCrmLeadFilters(params: URLSearchParams): CrmLeadFilters {
  const manager = params.get(CRM_FILTER_PARAM.manager) || null;
  return {
    search: params.get(CRM_FILTER_PARAM.search) ?? '',
    manager: manager === MANAGER_FILTER_ALL ? null : manager,
  };
}

/**
 * "Мои" (manager=me) есть только у входа со своей записью менеджера: у остальных
 * backend отвечает 400, поэтому me игнорируется. hasOwnManager null: пользователь
 * ещё не загружен, фильтр не трогаем.
 */
export function withoutForeignMe(filters: CrmLeadFilters, hasOwnManager: boolean | null): CrmLeadFilters {
  return hasOwnManager === false && filters.manager === MANAGER_FILTER_ME ? { ...filters, manager: null } : filters;
}

/** params запроса: search (обрезан, пустой не шлётся), manager. */
export function crmLeadFilterParams(filters: CrmLeadFilters): CrmLeadFilterParams {
  const params: CrmLeadFilterParams = {};
  const search = filters.search.trim();
  if (search) params.search = search;
  if (filters.manager) params.manager = filters.manager;
  return params;
}

/** Задан хотя бы один фильтр (для текста "Ничего не найдено"). */
export function hasCrmLeadFilters(params: CrmLeadFilterParams): boolean {
  return Boolean(params.search || params.manager);
}
